<template>
  <div class="login-container">
    <div>
      <svg t="1711187944001" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9561" width="88" height="88"><path d="M146.6 771.8c-18.8-62.6 49.9-93.6 40.3-178.6-8.4-74.8-63.2-84.2-66.3-148.1-4.9-100.5 127.4-178.9 143-188.2 89.6-53.1 237.1-84.8 312.9-17.8 56.3 49.8 24.7 111.3 86.3 158.1 66.6 50.7 133 1.1 188.8 48.9 61.4 52.6 42.9 165.6 37 201.9C870 761.8 788.4 905.2 685.3 913.4c-78.7 6.3-96.2-72.2-203.7-75.1-81.8-2.2-98.7 42.5-178.7 33.3-57.4-6.8-138.3-40.1-156.3-99.8z" fill="#5653DA" p-id="9562"></path><path d="M158.9 747c-18.8-62.6 49.9-93.6 40.3-178.6-8.4-74.8-63.2-84.2-66.3-148.1-4.9-100.5 127.4-178.9 143-188.2 89.6-53.1 237.1-84.8 312.9-17.8 56.3 49.8 24.7 111.3 86.3 158.1 66.6 50.7 133 1.1 188.8 48.9 61.4 52.6 42.9 165.6 37 201.9C882.3 737 800.7 880.3 697.6 888.5c-78.7 6.3-96.2-72.2-203.7-75.1-81.8-2.2-98.7 42.5-178.7 33.3-57.3-6.6-138.3-39.9-156.3-99.7z" fill="#725CDA" p-id="9563"></path><path d="M830.3 458.3c-4 7.7-13.6 10.6-21.2 6.6-7.7-4-10.6-13.6-6.6-21.2a15.7 15.7 0 1 1 27.8 14.6z m-20.2-10.7c-1.8 3.5-0.5 7.8 3 9.7 3.5 1.8 7.8 0.5 9.7-3 1.8-3.5 0.5-7.8-3-9.7-3.5-1.8-7.9-0.5-9.7 3zM268.5 782.6c5.7 6.5 5.1 16.4-1.4 22.2-6.5 5.7-16.4 5.1-22.2-1.4-5.7-6.5-5.1-16.4 1.4-22.2a15.7 15.7 0 0 1 22.2 1.4z m-17.2 15.1c2.6 3 7.1 3.3 10.1 0.7 3-2.6 3.3-7.1 0.7-10.1-2.6-3-7.1-3.3-10.1-0.7-3 2.6-3.3 7.1-0.7 10.1zM332.2 298.9c-6.1 11.6-20.5 16-32.1 9.9-11.6-6.1-16-20.5-9.9-32.1 6.1-11.6 20.5-16 32.1-9.9 11.5 6.2 16 20.6 9.9 32.1z m-34.4-18.1c-3.9 7.4-1.1 16.6 6.3 20.5 7.4 3.9 16.6 1.1 20.5-6.3 3.9-7.4 1.1-16.6-6.3-20.5-7.4-4-16.6-1.1-20.5 6.3zM220.9 492.3c1.4 1.6 1.2 3.9-0.3 5.3l-17.8 15.6a3.78 3.78 0 0 1-5.3-0.3c-1.4-1.6-1.2-3.9 0.3-5.3l17.8-15.6c1.6-1.4 3.9-1.2 5.3 0.3zM266.1 452.7c1.4 1.6 1.2 3.9-0.3 5.3L248 473.6a3.78 3.78 0 0 1-5.3-0.3c-1.4-1.6-1.2-3.9 0.3-5.3l17.8-15.6c1.6-1.4 3.9-1.3 5.3 0.3zM206.9 448.8l15.6 17.8c1.4 1.6 1.2 3.9-0.3 5.3a3.78 3.78 0 0 1-5.3-0.3l-15.6-17.8c-1.4-1.6-1.2-3.9 0.3-5.3s4-1.2 5.3 0.3zM246.6 494l15.6 17.8c1.4 1.6 1.2 3.9-0.3 5.3a3.78 3.78 0 0 1-5.3-0.3L241 498.9c-1.4-1.6-1.2-3.9 0.3-5.3 1.6-1.3 3.9-1.1 5.3 0.4z" fill="#FFFFFF" p-id="9564"></path><path d="M820.9 637.3c1.4 1.6 1.2 3.9-0.3 5.3l-17.8 15.6a3.78 3.78 0 0 1-5.3-0.3c-1.4-1.6-1.2-3.9 0.3-5.3l17.8-15.6c1.6-1.4 3.9-1.2 5.3 0.3zM866.1 597.7c1.4 1.6 1.2 3.9-0.3 5.3L848 618.6a3.78 3.78 0 0 1-5.3-0.3c-1.4-1.6-1.2-3.9 0.3-5.3l17.8-15.6c1.6-1.4 3.9-1.3 5.3 0.3z" fill="#FFFFFF" p-id="9565"></path><path d="M806.9 593.8l15.6 17.8c1.4 1.6 1.2 3.9-0.3 5.3a3.78 3.78 0 0 1-5.3-0.3l-15.6-17.8c-1.4-1.6-1.2-3.9 0.3-5.3 1.6-1.4 4-1.2 5.3 0.3zM846.6 639l15.6 17.8c1.4 1.6 1.2 3.9-0.3 5.3a3.78 3.78 0 0 1-5.3-0.3L841 643.9c-1.4-1.6-1.2-3.9 0.3-5.3 1.6-1.3 3.9-1.1 5.3 0.4z" fill="#FFFFFF" p-id="9566"></path><path d="M586.2 139.9a18 18 0 0 0-16.5 10.7c-30.4 8.7-44 44.1-47.8 56h-2.7c-3.8-11.9-17.3-47.3-47.8-56a18.1 18.1 0 1 0 1 11.9c20.7 8.6 31.6 33.4 35.6 44.8-25 2.2-43.5 10.4-43.5 20.2 0 11.4 25 20.6 56.1 20.9 31.1-0.2 56.1-9.5 56.1-20.9 0-9.8-18.5-18-43.5-20.2 4-11.4 14.9-36.2 35.6-44.8a18.1 18.1 0 0 0 35.6-4.5c-0.1-10-8.2-18.1-18.2-18.1z" fill="#FD595E" p-id="9567"></path><path d="M576.7 377H464.5v64.7h112.2z" fill="#FCA360" p-id="9568"></path><path d="M613.7 222.1H427.4c-38.4 0 0 165 0 165h186.3s38.4-165 0-165z" fill="#313145" p-id="9569"></path><path d="M502.2 283.9c0 16.1-13.1 29.2-29.2 29.2s-29.2-13.1-29.2-29.2 13.1-29.2 29.2-29.2 29.2 13 29.2 29.2z" fill="#FD595E" p-id="9570"></path><path d="M486.2 283.9c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2 7.3-0.1 13.2 5.9 13.2 13.2z" fill="#313145" p-id="9571"></path><path d="M430.8 682.5h43.1v95.3h-43.1z m136.4 0h43.1v95.3h-43.1z" fill="#FFFFFF" p-id="9572"></path><path d="M448.2 699.4c-5.7 0.3-10.9 2.3-15.2 5.4l41.4 37.1c2.7-4.6 4.1-10 3.8-15.7a28.5 28.5 0 0 0-30-26.8z m3.1 56.8c4.7-0.3 9.1-1.7 12.9-3.9l-40.4-36.2a28 28 0 0 0-2.5 13.3c0.9 15.6 14.4 27.6 30 26.8z m22.6-56.1v-68.9h-43.1v65.1c5.1-3.1 10.9-4.9 17-5.2 9.9-0.6 19.2 2.9 26.1 9z m-22.1 64.4c-0.7 0-1.4 0.1-2 0.1-6.9 0-13.4-2-19-5.3v78.5h43.1v-75.1l-4.3-3.9c-5.2 3.3-11.2 5.4-17.8 5.7z" fill="#313145" p-id="9573"></path><path d="M538.9 283.8c0 16.1 13.1 29.2 29.2 29.2s29.2-13.1 29.2-29.2-13.1-29.2-29.2-29.2-29.2 13.1-29.2 29.2z" fill="#FD595E" p-id="9574"></path><path d="M554.9 283.8c0 7.3 5.9 13.2 13.2 13.2s13.2-5.9 13.2-13.2c0-7.3-5.9-13.2-13.2-13.2s-13.2 5.9-13.2 13.2z" fill="#313145" p-id="9575"></path><path d="M554.9 336.6h-68.7v21.6h34.4v-0.1h34.3z" fill="#FFFFFF" p-id="9576"></path><path d="M592.9 699.4a28.42 28.42 0 0 0-30 26.8c-0.3 5.7 1.1 11.1 3.8 15.7l41.4-37.1c-4.3-3.1-9.5-5.1-15.2-5.4z m-3.1 56.7c15.7 0.9 29.1-11.2 29.9-26.8 0.3-4.7-0.7-9.2-2.5-13.3l-40.4 36.2c3.9 2.3 8.3 3.7 13 3.9z m3.6-65.1c6.1 0.3 11.9 2.1 17 5.2v-65.1h-43.1V700c6.9-6 16.1-9.5 26.1-9z m-4.1 73.5c-6.6-0.4-12.6-2.4-17.8-5.8l-4.3 3.9v75.1h43.1v-78.5c-5.6 3.4-12 5.3-19 5.3h-2z" fill="#313145" p-id="9577"></path><path d="M311.1 499.2s-4.6 27.6-4.6 62.4l27.3 19 15.8-16.3s-0.7-46.6 4.5-58.5l-1.7-19.2-34.5 8.9-6.8 3.7z m418.9 0s4.6 27.6 4.6 62.4l-27.3 19-15.8-16.3s0.7-46.6-4.5-58.5l1.7-19.2 34.5 8.9 6.8 3.7z" fill="#FFFFFF" p-id="9578"></path><path d="M326.5 503.7c-5.7 0.3-10.8 2.3-15.1 5.4l41 36.8a28.17 28.17 0 0 0-25.9-42.2z m3.1 56.3c4.7-0.3 9-1.7 12.8-3.9l-40-35.9c-1.8 4-2.7 8.5-2.5 13.2 0.9 15.6 14.2 27.5 29.7 26.6z m0.5 8.6c-0.7 0-1.4 0.1-2 0.1-8 0-15.5-2.6-21.5-7V651h43.1v-86.6l-1.8-1.6a36.5 36.5 0 0 1-17.8 5.8z m384.5-64.9c-15.5-0.9-28.8 11.1-29.7 26.6-0.3 5.7 1.1 11 3.7 15.6l41-36.8c-4.2-3.1-9.3-5-15-5.4z m-3.1 56.3c15.5 0.9 28.8-11.1 29.7-26.6 0.3-4.7-0.7-9.2-2.5-13.2l-40 35.9c3.8 2.3 8.1 3.7 12.8 3.9z" fill="#FD595E" p-id="9579"></path><path d="M687.1 506a36.7 36.7 0 0 1 28-10.8c5.3 0.3 10.3 1.7 14.9 4.1-12.5-43.9-48.1-80.5-77.2-82.9l-132.2-0.2-132.2 0.2c-29.1 2.4-64.8 39-77.2 82.9 4.6-2.4 9.6-3.8 14.9-4.1a36.7 36.7 0 0 1 28 10.8c8.9-25.4 28.8-44.4 37.1-46.6L403 639.3h235.2L650 459.4c8.3 2.2 28.2 21.2 37.1 46.6z m24 62.6c-6.6-0.4-12.6-2.4-17.8-5.8l-1.8 1.6V651h43.1v-89.4c-6.1 4.4-13.5 7-21.5 7-0.7 0.1-1.4 0-2 0z" fill="#FD595E" p-id="9580"></path><path d="M436.9 466.9h178.9v9.2H436.9z" fill="#313145" p-id="9581"></path><path d="M436.9 491.1h178.9v9.2H436.9z" fill="#FFFFFF" p-id="9582"></path><path d="M436.9 516.7h178.9v9.2H436.9z" fill="#313145" p-id="9583"></path><path d="M436.9 542.3h178.9v9.2H436.9z" fill="#FFFFFF" p-id="9584"></path><path d="M436.9 567.5h178.9v9.2H436.9z" fill="#313145" p-id="9585"></path><path d="M436.9 593.1h178.9v9.2H436.9z" fill="#FFFFFF" p-id="9586"></path><path d="M283.8 650.7c0-10.8 8.8-19.5 19.6-19.5h48.9c10.8 0 19.5 8.8 19.5 19.6v0.3c0.3 1.2 0.5 2.4 0.5 3.7v23.8c0 8.7-7 15.7-15.7 15.7s-15.7-7-15.7-15.7v-8.3h-25.6v8.3c0 8.7-7.1 15.7-15.7 15.7-8.7 0-15.7-7-15.7-15.7v-23.8c0-0.7 0.1-1.4 0.2-2-0.1-0.8-0.3-1.4-0.3-2.1z m473.5 0c0-10.8-8.8-19.5-19.6-19.5h-48.9c-10.8 0-19.5 8.8-19.5 19.6v0.3c-0.3 1.2-0.5 2.4-0.5 3.7v23.8c0 8.7 7 15.7 15.7 15.7s15.7-7 15.7-15.7v-8.3h25.6v8.3c0 8.7 7 15.7 15.7 15.7s15.7-7 15.7-15.7v-23.8c0-0.7-0.1-1.4-0.2-2 0.2-0.8 0.3-1.4 0.3-2.1z" fill="#313145" p-id="9587"></path><path d="M393.3 872.3h111.4c0-30.8-24.9-55.7-55.7-55.7-30.8 0.1-55.7 25-55.7 55.7z m254.5 0H536.4c0-30.8 24.9-55.7 55.7-55.7 30.8 0 55.7 24.9 55.7 55.7z" fill="#FD595E" p-id="9588"></path><path d="M499 344.1h43.2v6.6H499z" fill="#313145" p-id="9589"></path></svg>
    </div>
    <el-form
      :model="loginForm"
      :rules="rules2"
      status-icon
      ref="loginForm"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-page"
    >
      <h3 class="title">系统登录</h3>
      <el-form-item prop="uname">
        <el-input
          type="text"
          v-model="loginForm.uname"
          placeholder="用户名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="loginForm.password"
          placeholder="密码"
          @keyup.enter.native="handleSubmit"
        ></el-input>
      </el-form-item>
      <el-form-item style="width: 100%">
        <el-button
          type="primary"
          style="width: 100%"
          @click="handleSubmit"
          :loading="logining"
        >登录
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '@/api/api'

export default {
  name: 'Login',
  data () {
    return {
      logining: false,
      loginForm: {
        uname: '',
        password: ''
      },
      rules2: {
        uname: [
          {
            required: true,
            message: '请输入您的账号',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入您的密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.logining = true
          api.login(this.loginForm).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.$router.push('/charts')
            } else {
              this.$message.error('登录失败，' + res.message)
            }
          }).catch(e => {
            this.$message.error('登录失败，' + e)
          }).finally(_ => {
            this.logining = false
          })
        } else {
          this.$message.error('验证失败')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  height: 80%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-page {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  width: 255px;
  padding: 35px 35px 15px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
}
</style>
